import React from 'react';
import { Box, Card, Typography } from '@mui/material';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';

const PortfolioHealth = ({ good = 49, warning = 63, critical = 158 }) => {
  const total = good + warning + critical;

  const data = [
    { name: 'Gut', value: good, color: '#1E9E5A' },
    { name: 'Achtung', value: warning, color: '#E0901B' },
    { name: 'Kritisch', value: critical, color: '#C80F2E' }
  ];

  return (
    <Card
      sx={{
        background: '#FFFFFF',
        border: '1px solid #ECEBEE',
        borderRadius: '18px',
        padding: '24px',
        boxShadow: '0 1px 2px rgba(16,16,20,.06), 0 2px 6px rgba(16,16,20,.05)',
      }}
    >
      {/* Header */}
      <Typography
        sx={{
          fontSize: '18px',
          fontWeight: 700,
          color: '#0A0A0B',
          fontFamily: 'Plus Jakarta Sans, system-ui',
          mb: 2
        }}
      >
        Portfolio-Gesundheit
      </Typography>

      {/* Content: Chart Left, Legend Right */}
      <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '24px', alignItems: 'center' }}>
        {/* Left: Donut Chart with Center Text */}
        <Box sx={{ position: 'relative', width: '160px', height: '160px', justifySelf: 'center' }}>
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={data}
                cx="50%"
                cy="50%"
                innerRadius={45}
                outerRadius={75}
                paddingAngle={2}
                dataKey="value"
                startAngle={90}
                endAngle={-270}
              >
                {data.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
              </Pie>
            </PieChart>
          </ResponsiveContainer>

          {/* Center Text - Absolute Positioning */}
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              textAlign: 'center',
              zIndex: 1,
              pointerEvents: 'none'
            }}
          >
            <Typography
              sx={{
                fontSize: '24px',
                fontWeight: 700,
                color: '#0A0A0B',
                fontFamily: 'JetBrains Mono, monospace',
                lineHeight: 1
              }}
            >
              {total}
            </Typography>
            <Typography
              sx={{
                fontSize: '12px',
                fontWeight: 500,
                color: '#55555D',
                fontFamily: 'Plus Jakarta Sans, system-ui'
              }}
            >
              Konten
            </Typography>
          </Box>
        </Box>

        {/* Right: Legend */}
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          {data.map((item, idx) => (
            <Box
              key={idx}
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px'
              }}
            >
              <Box
                sx={{
                  width: '10px',
                  height: '10px',
                  borderRadius: '2px',
                  backgroundColor: item.color,
                  flexShrink: 0
                }}
              />
              <Typography
                sx={{
                  fontSize: '13px',
                  fontWeight: 500,
                  color: '#0A0A0B',
                  fontFamily: 'Plus Jakarta Sans, system-ui',
                  flex: 1
                }}
              >
                {item.name}
              </Typography>
              <Typography
                sx={{
                  fontSize: '13px',
                  fontWeight: 700,
                  color: '#0A0A0B',
                  fontFamily: 'JetBrains Mono, monospace'
                }}
              >
                {item.value}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </Card>
  );
};

export default PortfolioHealth;
